export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban - Thumbnail.65b401eb.png";